import React from 'react';

import { clsx } from 'clsx';

import styles from './Ellipse.scss';

type Props = {
  id?: string;
  childrenClassNames?: {
    container?: string;
    ellipse?: string;
  };
};

const Ellipse: React.FC<Props> = ({ id = '', childrenClassNames = {} }) => {
  return (
    <div id={id} className={childrenClassNames.container}>
      <div className={styles.ellipseAnimation}>
        <img
          className={clsx(styles.ellipse, childrenClassNames.ellipse)}
          src="data:image/svg+xml;charset=UTF-8,%3csvg width='500' viewBox='-2 -2 203 83' xmlns='http://www.w3.org/2000/svg'%3e%3cellipse cx='100' cy='40' rx='100' ry='40' stroke-width='2' stroke='url(%23gradient_1)' fill='transparent'%3e%3c/ellipse%3e%3cdefs%3e%3clinearGradient id='gradient_1' x1='0' y1='0' x2='200' y2='200' gradientUnits='userSpaceOnUse'%3e%3canimate attributeName='x1' values='0;200;200;0;0' dur='5s' repeatCount='indefinite'%3e%3c/animate%3e%3canimate attributeName='x2' values='200;0;0;200;200' dur='5s' repeatCount='indefinite'%3e%3c/animate%3e%3canimate attributeName='y1' values='-50;-50;150;150;-50' dur='5s' repeatCount='indefinite'%3e%3c/animate%3e%3canimate attributeName='y2' values='150;150;-50;-50;150' dur='5s' repeatCount='indefinite'%3e%3c/animate%3e%3cstop stop-color='%23EED7F1'%3e%3c/stop%3e%3cstop offset='0.084745' stop-color='%23FEFCFE'%3e%3c/stop%3e%3cstop offset='0.191502' stop-color='%23DBC1D4'%3e%3c/stop%3e%3cstop offset='0.285358' stop-color='%236DD2E5'%3e%3c/stop%3e%3cstop offset='0.400018' stop-color='%237BA0EB'%3e%3c/stop%3e%3cstop offset='0.509667' stop-color='%23BC86F6'%3e%3c/stop%3e%3cstop offset='0.631842' stop-color='%23DCC4F8'%3e%3c/stop%3e%3cstop offset='0.747457' stop-color='%23BFB5C6'%3e%3c/stop%3e%3cstop offset='0.870443' stop-color='%23F5F4F6'%3e%3c/stop%3e%3cstop offset='1' stop-color='%23D7CACE'%3e%3c/stop%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e"
          alt="ellipse"
        />
      </div>
    </div>
  );
};

export default Ellipse;
